import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import CurrencyConverter from '../CurrencyConverter';
import ListNotFound from '../../routes/listNotFound/ListNotFound';
import NotFound from '../../routes/notFound/NotFound';
import HostClaimModal from '../HostClaimModal/HostClaimModal';
import ToolTipSection from '../Common/ToolTipSection/ToolTipSection';

import messages from '../../locale/jsonMessages';
import { formatTime } from '../../helpers/formatting';
import { convert } from '../../helpers/currencyConvertion';
import { isRTL } from '../../helpers/formatLocale';
import { generateTime } from './helper';
import { getDynamicName, getDynamicTitle } from '../../helpers/GetDynamicItemName/getDynamicName';
import { dateFormat } from '../../config';
import { formatLocalizedDate } from '../../helpers/formatLocateDate';
import { getPromoCodeDetailsValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';

//Images
import printIcon from '/public/SiteIcons/printer.png';
import arrowIcon from '/public/SiteIcons/paymentArrow.svg';

import cs from '../../components/commonStyle.css'
import s from './Receipt.css';

import OptionLines from '../ListingOptions/OptionLines';
import { getReservationOptionLines } from '../../helpers/bookingOptionsPresentation';
const PaymentReceipt = (props) => {

	const [showModal, setShowModal] = useState(false);

	const siteName = useSelector(state => state?.siteSettings?.data?.siteName);
	const userId = useSelector(state => state?.account?.data?.userId);
	const currencyRates = useSelector(state => state?.currency);
	const locale = useSelector(state => state.intl.locale);
	const dynamicLanguageData = useSelector(state => state?.dynamicListSettings?.data)
	const print = () => {
		window.print()
	}

	const changeModalState = (status = false) => setShowModal(status);

	const { data } = props;
	const { formatMessage } = useIntl();

	if (!data) {
		return <> <FormattedMessage {...messages.errorMessage} /> </>;
	} else if (!data.listData) {
		return <ListNotFound />
	} else if (data.paymentState !== "completed") {
		return <NotFound />
	} else {
		const { data, data: { id, listId, checkIn, checkOut, confirmationCode, createdAt, updatedAt, hostId, startTime, endTime, listTitle, dayDifference } } = props;
		const { data: { basePrice, delivery, total, discount, discountType, guestServiceFee, currency, hostServiceFee, claimRefundedAt } } = props;
		const { data: { hostData, guestData, licenseNumber, firstName, middleName, dateOfBirth, countryLabel, claimTransaction } } = props;
		const { data: { listData: { title, street, city, state, country, zipcode } } } = props;
		const { data: { listData: { listingData: { checkInStart, checkInEnd } } } } = props;
		const { data: { listData: { settingsData } }, refetch } = props;
		const { data: { bookingSpecialPricing, securityDeposit, claimRefund, claimAmount, claimStatus, claimImages, claimReason, cancellationDetails, reservationState, claimPayout, dynamicListTitle } } = props;
		const { data: { promoCode, promoDiscount, promoCodeDescription, promoCodeType, dynamicPromoCodeDetails } } = props;
		let roomType, createdDate, updatedDate, birthDate, claimRefundedDate, checkInDate, checkOutDate, isAverage = 0, subTotal, userType;
		let momentStartDate, momentEndDate, dayPrice = 0, checkInTime, checkOutTime, isSpecialPriceAssigned, modalInitialValues = {};
		let isDayTotal = 0, formattedStartTime, formattedEndTime, claimPaidAmount = claimTransaction?.amount, claimPaidCurrency = claimTransaction?.currency;
		roomType = getDynamicName({ value: settingsData[0]?.listsettings, locale, data: dynamicLanguageData });
		let dynamicTitleContent, dynamicTitle;
		if (dynamicListTitle) {
			dynamicTitleContent = JSON.parse(dynamicListTitle)
			dynamicTitle = getDynamicTitle({ data: dynamicTitleContent, locale, id: listId });
		}
		createdDate = createdAt ? formatLocalizedDate(createdAt, locale, dateFormat?.longDateFormat) : '';
		updatedDate = updatedAt ? formatLocalizedDate(updatedAt, locale, dateFormat?.longDateFormat) : '';
		birthDate = dateOfBirth ? moment(dateOfBirth, 'MM-DD-YYYY').format('L') : '';
		claimRefundedDate = claimRefundedAt ? formatLocalizedDate(claimRefundedAt, locale, dateFormat?.longDateFormat) : '';
		checkInDate = checkIn ? formatLocalizedDate(checkIn, locale, dateFormat?.longDateFormat) : '';
		checkOutDate = checkOut ? formatLocalizedDate(checkIn, locale, dateFormat?.longDateFormat) : '';
		isSpecialPriceAssigned = (bookingSpecialPricing && bookingSpecialPricing.length > 0) ? true : false;
		modalInitialValues.securityDeposit = convert(currencyRates.base, currencyRates.rates, securityDeposit, currency, currencyRates.to).toFixed(2);

		if (claimStatus && claimStatus != 'pending') {
			modalInitialValues.claimAmount = convert(currencyRates.base, currencyRates.rates, claimAmount, currency, currencyRates.to).toFixed(2);
			modalInitialValues.claimReason = claimReason;
			modalInitialValues.claimImages = claimImages;
		}

		if (isSpecialPriceAssigned) {
			bookingSpecialPricing && bookingSpecialPricing.map((item, index) => {
				dayPrice = dayPrice + Number(item.isSpecialPrice);
			});
		} else {
			dayPrice = basePrice * dayDifference;
		}

		if (checkInStart === 'Flexible') {
			checkInTime = formatMessage(messages.flexibleCheckIn);
		} else {
			checkInTime = generateTime(checkInStart);
		}

		if (checkInEnd === 'Flexible') {
			checkOutTime = formatMessage(messages.flexibleCheckOut);
		} else {
			checkOutTime = generateTime(checkInEnd);
		}

		if (userId === hostId) {
			userType = 'owner';
			let promoDiscountAmount = promoCodeType == "admin" ? Number(promoDiscount) : 0
			subTotal = (total + promoDiscountAmount) - hostServiceFee;
		} else {
			userType = 'renter';
			subTotal = total + guestServiceFee + securityDeposit;
		}

		isAverage = Number(dayPrice) / Number(dayDifference);
		isDayTotal = isAverage.toFixed(2) * dayDifference;
		dayPrice = isDayTotal;

		formattedStartTime = formatTime(startTime);
		formattedEndTime = formatTime(endTime);

		let checkOutDifference = 0;
		if (reservationState == 'completed') checkOutDifference = moment().diff(moment(parseInt(checkOut)), 'hour', true);
		if (cancellationDetails && reservationState == 'cancelled') {
			let todayDiff = moment().diff(moment(parseInt(checkIn)), 'hour', true);
			if (todayDiff > 0) checkOutDifference = moment().diff(moment(parseInt(cancellationDetails.createdAt)), 'hour', true);
		}

		let showSecurityDeposit = userType === "owner" && securityDeposit <= 0 ? false : true;

		const promoCodeDetails = JSON.parse(dynamicPromoCodeDetails || '[]');
		const dynamicValue = getPromoCodeDetailsValue(promoCodeDetails, locale);

		return (
			<Grid fluid className={cx(s.container, cs.spaceTop4)}>
				<Row>
					<Col lg={12} md={12} sm={12} xs={12}>
						{showModal && <HostClaimModal
							refetchData={refetch}
							claimed={Boolean(claimStatus && claimStatus != 'pending')}
							reservationId={id}
							show={showModal}
							currency={currency}
							changeModalState={changeModalState}
							initialValues={modalInitialValues}
						/>}
						<div className={cx(s.diplayFlex, cs.spaceTop5, s.fullWidthMobile)}>
							<div className={cs.spaceBottom4}>
								<h2 className={cx(cs.commonTitleText, cs.paddingBottom1, cs.fontWeightBold)}><FormattedMessage {...messages.customerReceipt} /></h2>
								<h4 className={cx(cs.commonContentText, cs.fontWeightNormal)}><FormattedMessage {...messages.receipt} />: #{id}</h4>
							</div>
							<a className={cx(cs.btnPrimary, "hidden-print", cs.displayInlineBlock, cs.spaceBottom4)} onClick={print}>
								<img src={printIcon} className={'commonIconSpace'} />
								<FormattedMessage {...messages.print} />
							</a>
						</div>
						<div className={s.receiptGrid}>
							<div className={cx(cs.spaceBottom4, { [s.directionRTLPrint]: isRTL(locale) })}>
								<div className={s.mainSection}>
									<h6 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.bookedBy} />: {guestData.firstName} </h6>
									<h4 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2)}><span><FormattedMessage {...messages.confirmationCode} />:</span> <span>#{confirmationCode}</span></h4>
									<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal)}>{createdDate}</h5>
									<hr className={cx(s.listingHorizoltalLine, cs.spaceBottom3, cs.spaceTop3)} />
									<>
										<h3 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.vehicleDetails} /></h3>
										<div className={s.displayGridDetails}>
											<>
												<h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom8)}><FormattedMessage {...messages.ownersName} /></h4>
												<a href={'/users/show/' + hostData.profileId} target={"_blank"} className={cx(cs.siteLinkColor, cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2, s.displayInline, "hidden-print")}>
													{hostData.firstName}
												</a>
												<span className={cx(cs.siteLinkColor, cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2, s.displayInline, 'printText')}>{hostData.firstName}</span>
											</>
											<>
												<h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom8)}><FormattedMessage {...messages.whatKindOfPlace} /></h4>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>{roomType?.itemName}</p>
											</>
										</div>
										<h5 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom8)}><FormattedMessage {...messages.location} /></h5>
										<a href={'/cars/' + listId} target={"_blank"} className={cx(cs.siteLinkColor, cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2, s.displayInline, "hidden-print")}>{dynamicTitle || (listTitle || title)}</a>
										<span className={cx(cs.siteLinkColor, cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2, s.displayInline, 'printText')}>{dynamicTitle || (listTitle || title)}</span>
										<p className={cx(cs.commonMediumText, cs.fontWeightNormal)}>
											<span>{street}</span>
											<span>{city}, {state} {zipcode}</span>{' '}
											<span>{country}</span>
										</p>
									</>
									<hr className={cx(s.listingHorizoltalLine, cs.spaceBottom3, cs.spaceTop3)} />
									<>
										<h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.tripDetails} /></h4>
										<div className={s.displayGridDate}>
											<h5 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.checkIn} /></h5>
											<span></span>
											<h5 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.checkOut} /></h5>
										</div>
										<div className={s.displayGridDate}>
											<div className={s.paddingRight}>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1)}>{checkInDate} </p>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>&lrm;{formattedStartTime}</p>
											</div>
											<span className={s.tripArrowIconSec}>
												<img src={arrowIcon} className={cx(cs.dateArrowMargin, 'commonDateArrowRTLRotate', 'printMobileArrow')} />
											</span>
											<div className={s.paddingRight}>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1)}>{checkOutDate}</p>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>&lrm;{formattedEndTime}</p>
											</div>
										</div>
										<div className={s.displayGridDetails}>
											<>
												<h6 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2, s.colSpaceRight, 'colReceiptSpaceLeftRTL')}><FormattedMessage {...messages.duration} /></h6>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</p>
											</>
											<>
												<h6 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.travelDestination} /></h6>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>{city}</p>
											</>
										</div>
										<h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.renterInfo} /></h4>
										<div className={s.displayGridDetails}>
											<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1, cs.dFlexWrapAlignStart, s.colSpaceRight, 'colReceiptSpaceLeftRTL')}>
												<span className={cx(cs.fontWeightMedium, s.infoDetailsPadding, 'receiptInfoDetailSpaceRTL')}><FormattedMessage {...messages.name} />:</span>
												<span>{firstName} {middleName && <>{middleName}</>}</span>
											</p>
											<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1, cs.dFlexWrapAlignStart)}>
												<span className={cx(cs.fontWeightMedium, s.infoDetailsPadding, 'receiptInfoDetailSpaceRTL')}><FormattedMessage {...messages.dob} />:</span>
												<span>{birthDate}</span>
											</p>
											<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1, cs.dFlexWrapAlignStart, s.colSpaceRight, 'colReceiptSpaceLeftRTL')}>
												<span className={cx(cs.fontWeightMedium, s.infoDetailsPadding, 'receiptInfoDetailSpaceRTL')}><FormattedMessage {...messages.licenseNumber} />:</span>
												<span>{licenseNumber}</span>
											</p>
											{countryLabel && <p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1, cs.dFlexWrapAlignStart)}>
												<span className={cx(cs.fontWeightMedium, s.infoDetailsPadding, 'receiptInfoDetailSpaceRTL')}><FormattedMessage {...messages.country} />:</span>
												<span>{countryLabel}</span>
											</p>}
										</div>
									</>
								</div>
							</div>
							<div className={cx({ [s.directionRTLPrint]: isRTL(locale) }, s.positionStickey)}>
								<div className={cx(s.mainSection, cs.spaceBottom4, s.bgColor, 'bgColorPrint')}>
									<h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.billing} /></h4>

									<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
										<div className={cx(cs.commonSmallText16, cs.textStart)}>
											<div className='tooltipFlex'>
												{isSpecialPriceAssigned &&
													<ToolTipSection label={formatMessage(messages.averageRate)}
														tooltipIconClass={cx(cs.positionRelative, cs.top3, "hidden-print")} />}
												<div>
													<CurrencyConverter amount={isAverage} from={currency} />
													<span className={cs.displayinlineBlock}>&nbsp;{'x'}&nbsp;&rlm;{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</span>
												</div>
											</div>
										</div>
										<div className={cx(cs.commonSmallText16, cs.textEnd)}>
											<CurrencyConverter amount={dayPrice} from={currency} />
										</div>
									</div>


									{
										discount > 0 &&
										<div className={cx(cs.dataTableGrid, cs.paymentDivider, 'discountText')}>
											<div className={cx(cs.commonSmallText16, cs.textStart)}>{discountType}</div>
											<div className={cx(cs.commonSmallText16, cs.textEnd)}>
												<span>-&nbsp;<CurrencyConverter amount={discount} from={currency} /></span>
											</div>
										</div>
									}

									{
										promoDiscount > 0 && (userType == 'renter' || userType == 'owner' && promoCodeType == 'host') &&
										<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
											<div className={cx(cs.commonSmallText16, cs.textStart)}>
												<div className="tooltipFlex">
													<ToolTipSection label={dynamicValue?.description ? dynamicValue?.description : promoCodeDescription} tooltipIconClass={cx(cs.positionRelative, cs.top3, "hidden-print")} />
													<span className='discountText'>{promoCode}</span>
												</div>
											</div>
											<div className={cx(cs.commonSmallText16, cs.textEnd, 'discountText')}>
												<span>-&nbsp; <CurrencyConverter amount={promoDiscount} from={currency} /></span>
											</div>
										</div>
									}

									<OptionLines lines={getReservationOptionLines(data)} currency={currency} titleMessage={messages.boIncluded} showLocation />

									{
										userType === 'renter' && guestServiceFee > 0 &&
										<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
											<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.serviceFee} /></div>
											<div className={cx(cs.commonSmallText16, cs.textEnd)}>
												<CurrencyConverter amount={guestServiceFee} from={currency} />
											</div>
										</div>
									}

									{
										userType === 'owner' && hostServiceFee > 0 &&
										<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
											<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.serviceFee} /></div>
											<div className={cx(cs.commonSmallText16, cs.textEnd)}>
												<span>-&nbsp; <CurrencyConverter amount={hostServiceFee} from={currency} /></span>
											</div>
										</div>
									}
									{
										userType === 'renter' && securityDeposit > 0 &&
										<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
											<div className={cx(cs.commonSmallText16, cs.textStart)}>
												<FormattedMessage {...messages.securityDeposit} />
											</div>
											<div className={cx(cs.commonSmallText16, cs.textEnd)}>
												<CurrencyConverter amount={securityDeposit} from={currency} />
											</div>
										</div>
									}

									{userType === 'renter' && data.reservationState != 'cancelled' &&
										<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
											<div className={cx(cs.commonSmallText16, cs.fontWeightBold, cs.textStart)}><FormattedMessage {...messages.total} /></div>
											<div className={cx(cs.commonSmallText16, cs.fontWeightBold, cs.textEnd)}>
												<CurrencyConverter amount={subTotal} from={currency} />
											</div>
										</div>
									}

									{userType === 'owner' &&
										<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
											<div className={cx(cs.commonSmallText16, cs.fontWeightBold, cs.textStart)}>
												{reservationState == 'completed' ? <FormattedMessage {...messages.earnings} /> :
													<FormattedMessage {...messages.estimatedEarnings} />
												}
											</div>
											<div className={cx(cs.commonSmallText16, cs.fontWeightBold, cs.textEnd)}>
												<CurrencyConverter amount={subTotal > 0 ? subTotal : 0} from={currency} />
											</div>
										</div>
									}

									{userType === 'owner' && reservationState == 'cancelled' && cancellationDetails &&
										<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
											<div className={cx(cs.commonSmallText16, cs.fontWeightBold, cs.textStart)}><FormattedMessage {...messages.actualEarnings} /></div>
											<div className={cx(cs.commonSmallText16, cs.fontWeightBold, cs.textEnd)}>
												<CurrencyConverter amount={cancellationDetails.payoutToHost} from={currency} />
											</div>
										</div>
									}
								</div>

								{showSecurityDeposit &&
									<div className={cx(s.mainSection, cs.spaceBottom4)}>
										{userType === 'renter' &&
											<h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.payment} /></h4>}
										{
											userType === 'renter' &&
											<>
												<div className={cs.dataTableGrid}>
													<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.paid} /></div>
													<div className={cx(cs.commonSmallText16, cs.textEnd)}>
														<CurrencyConverter amount={subTotal} from={currency} />
													</div>
												</div>
												<p className={cx(cs.commonContentText, cs.fontWeightNormal, cs.spaceTop1)}>{updatedDate}</p>
											</>
										}
										{
											userType === 'owner' && securityDeposit > 0 &&
											<>
												<div className={cx(cs.dataTableGrid, cs.spaceTop2)}>
													<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.securityDepositByRenter} /></div>
													<div className={cx(cs.commonSmallText16, cs.textEnd)}>
														<CurrencyConverter amount={securityDeposit} from={currency} />
													</div>
												</div>

												{claimStatus == 'pending' && checkOutDifference > 0 && checkOutDifference < 24 &&
													<div className={cs.spaceTop1}>
														<a className={cx(cs.siteLinkColor, cs.curserPointer, cs.commonContentText, cs.fontWeightMedium)}
															onClick={() => changeModalState(true)}>{' ('}<FormattedMessage {...messages.claimDamage} />{')'}</a>
													</div>}
												{claimAmount > 0 && <div className={cs.spaceTop1}>
													<a className={cx(cs.siteLinkColor, cs.curserPointer, cs.commonContentText, cs.fontWeightMedium)}
														onClick={() => changeModalState(true)}>{' ('}<FormattedMessage {...messages.claimDetails} />{')'}</a>
												</div>}

											</>
										}
										{
											userType === 'renter' && (['approved', 'fullyRefunded'].includes(claimStatus)) &&
											<>
												<div className={cx(cs.dataTableGrid, cs.spaceTop2)}>
													<div className={cx(cs.commonSmallText16, cs.textStart)}>
														<FormattedMessage {...messages.refundedSecurityDeposit} />
													</div>
													<div className={cx(cs.commonSmallText16, cs.textEnd)}>
														<CurrencyConverter amount={claimRefund} from={currency} />
													</div>
												</div>
												<p className={cx(cs.commonContentText, cs.fontWeightNormal, cs.spaceTop1)}>{claimRefundedDate}</p>

												{securityDeposit > 0 && claimAmount > 0 &&
													<div className={cs.spaceTop1}>
														<a className={cx(cs.siteLinkColor, cs.curserPointer, cs.commonContentText, cs.fontWeightMedium)}
															onClick={() => changeModalState(true)}>{' ('}<FormattedMessage {...messages.claimDetails} />{')'}</a>
													</div>}
											</>
										}
										{
											userType === 'owner' && claimStatus == 'approved' && claimPayout > 0 &&
											<>
												<div className={cx(cs.dataTableGrid, cs.spaceTop2)}>
													<div className={cx(cs.commonSmallText16, cs.textStart)}>
														<FormattedMessage {...messages.claimPaidToHost} />
													</div>
													<div className={cx(cs.commonSmallText16, cs.textEnd)}>
														<CurrencyConverter amount={claimPayout} from={currency} />
													</div>
												</div>
												<p className={cx(cs.commonContentText, cs.fontWeightNormal, cs.spaceTop1)}>{claimRefundedDate}</p>
											</>
										}
									</div>}
							</div>
						</div>
						<p className={cx(cs.commonContentText, cs.fontWeightNormal, cs.paddingBottom2)}>
							{siteName} <FormattedMessage {...messages.receiptInfo1} />{' '}
							<FormattedMessage {...messages.receiptInfo2} /> {siteName}.{' '}
							<FormattedMessage {...messages.receiptInfo3} /> {siteName}.
						</p>
					</Col>
				</Row>
			</Grid >
		);
	}
}

PaymentReceipt.propTypes = {
	formatMessage: PropTypes.any,
	siteName: PropTypes.string.isRequired,
	data: PropTypes.shape({
		id: PropTypes.number.isRequired,
		listId: PropTypes.number.isRequired,
		checkIn: PropTypes.string.isRequired,
		checkOut: PropTypes.string.isRequired,
		basePrice: PropTypes.number.isRequired,
		delivery: PropTypes.number.isRequired,
		total: PropTypes.number.isRequired,
		discount: PropTypes.number.isRequired,
		discountType: PropTypes.string,
		guestServiceFee: PropTypes.number.isRequired,
		currency: PropTypes.string.isRequired,
		confirmationCode: PropTypes.number.isRequired,
		createdAt: PropTypes.string.isRequired,
		updatedAt: PropTypes.string.isRequired,
		listData: PropTypes.shape({
			id: PropTypes.number.isRequired,
			title: PropTypes.string.isRequired,
			street: PropTypes.string.isRequired,
			city: PropTypes.string.isRequired,
			state: PropTypes.string.isRequired,
			country: PropTypes.string.isRequired,
			zipcode: PropTypes.string.isRequired,
			listingData: PropTypes.shape({
				checkInStart: PropTypes.string.isRequired,
				checkInEnd: PropTypes.string.isRequired
			}),
			settingsData: PropTypes.arrayOf(PropTypes.shape({
				id: PropTypes.number,
				listsettings: PropTypes.shape({
					itemName: PropTypes.string.isRequired
				})
			}))
		}),
		hostData: PropTypes.shape({
			displayName: PropTypes.string.isRequired,
		}),
		guestData: PropTypes.shape({
			displayName: PropTypes.string.isRequired,
		}),
		bookingSpecialPricing: PropTypes.array,
	})
};

PaymentReceipt.defaultProps = {
	data: null
};
export default withStyles(cs, s)(PaymentReceipt);
